
import { useMemo } from 'react';

interface FormSectionButtonProps {
  isComplete: boolean;
  isEdited: boolean;
  hasUnsavedChanges?: boolean;
}

export const useFormSectionButton = ({
  isComplete,
  isEdited,
  hasUnsavedChanges = false
}: FormSectionButtonProps) => {
  return useMemo(() => {
    const showButton = isComplete || hasUnsavedChanges;
    
    let buttonText = "Continue";
    if (isEdited) {
      buttonText = hasUnsavedChanges ? "Save" : "Continue";
    }
    
    const buttonEnabled = isComplete && (!isEdited || hasUnsavedChanges);
    
    return {
      showButton,
      buttonText,
      buttonEnabled
    };
  }, [isComplete, isEdited, hasUnsavedChanges]);
};
